import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { MapPin, Clock, Send, MessageCircle } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";
import Monogram from "./Monogram";

export default function Footer() {
  const [settings, setSettings] = useState(null);
  const [email, setEmail] = useState("");
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/estudio") || location.pathname === "/login";

  useEffect(() => {
    api.get("/settings/public").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  const subscribe = async () => {
    const v = email.trim();
    if (!v || !v.includes("@")) { toast.error("Ingresá un correo válido"); return; }
    try {
      await api.post("/subscribers", { kind: "email", value: v });
      toast.success("¡Gracias! Te avisaremos cuando haya nueva prédica.");
      setEmail("");
    } catch { toast.error("No pudimos registrar tu suscripción."); }
  };

  if (isAdmin) return null;

  return (
    <footer className="mt-24 border-t border-[#ECE6D8] bg-[#F5EFE2]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <Monogram />
            <div className="font-display text-xl font-bold tracking-tight text-[#1B1C1A]">Casa de Oración · CDE</div>
          </div>
          <p className="text-base text-[#3F433C] leading-relaxed">
            Pastor Osvaldo Paiva · Pastor principal · Iglesia Casa de Oración, Ciudad del Este, Alto Paraná, Paraguay.
          </p>
        </div>
        <div>
          <div className="eyebrow mb-3">Visitanos</div>
          <div className="flex items-start gap-2 mb-3">
            <MapPin size={20} className="mt-0.5 text-[#A36A00]" />
            <div className="text-base text-[#1B1C1A]" data-testid="footer-address">
              {settings?.address || <span className="italic text-[#55594F]">La dirección se publicará pronto.</span>}
            </div>
          </div>
          <div className="flex items-start gap-2 mb-5">
            <Clock size={20} className="mt-0.5 text-[#A36A00]" />
            <div className="text-base whitespace-pre-line text-[#1B1C1A]" data-testid="footer-hours">
              {settings?.service_hours || <span className="italic text-[#55594F]">Horarios de culto por confirmar.</span>}
            </div>
          </div>
          <div className="flex gap-2 flex-wrap">
            <a
              className="pill pill-sm pill-gold"
              href={settings?.maps_url || "https://share.google/6s7fUwqi81sitv2UO"}
              target="_blank"
              rel="noreferrer"
              data-testid="btn-como-llegar"
            >
              Cómo llegar →
            </a>
            {settings?.whatsapp_channel_url && (
              <a
                className="pill pill-sm pill-outline"
                href={settings.whatsapp_channel_url}
                target="_blank"
                rel="noreferrer"
                data-testid="btn-footer-wa-channel"
              >
                <MessageCircle size={16} /> Canal de WhatsApp
              </a>
            )}
          </div>
        </div>
        <div>
          <div className="eyebrow mb-3">Recibí cada prédica</div>
          <label className="text-sm font-semibold text-[#3F433C] block mb-1.5">Correo</label>
          <div className="flex gap-2">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@correo.com"
              className="input-dark"
              data-testid="input-email-subscribe"
            />
            <button onClick={subscribe} className="pill pill-primary !h-[56px] !px-5" data-testid="btn-subscribe-email"><Send size={18} /></button>
          </div>
          <p className="text-sm text-[#55594F] mt-3">Te mandamos cada prédica nueva con audio, resumen y PDF. Podés darte de baja cuando quieras.</p>
        </div>
      </div>
      <div className="border-t border-[#ECE6D8] py-5 text-center text-sm text-[#55594F]">
        © {new Date().getFullYear()} Iglesia Casa de Oración · Ciudad del Este — Hecho con fe.
      </div>
    </footer>
  );
}
